import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, Select, InputNumber, Switch, Row, Col } from 'antd';
import { LlmProviderType } from '@wellverse/shared-ts';

export const LlmProviderEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'llm-providers' });
  const record = queryResult?.data?.data as any;

  return (
    <Edit resource="llm-providers" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Type" name="type" rules={[{ required: true }]}>
          <Select
            placeholder="Select provider type"
            options={[
              { label: 'OpenAI', value: LlmProviderType.OPENAI },
              { label: 'Anthropic', value: LlmProviderType.ANTHROPIC },
              { label: 'Custom', value: LlmProviderType.CUSTOM },
            ]}
          />
        </Form.Item>
        <Form.Item label="API Key" name="apiKey">
          <Input.Password
            placeholder={record?.maskedApiKey ? `Current: ${record.maskedApiKey}` : 'Leave empty to keep existing key'}
          />
        </Form.Item>
        <Form.Item label="Base URL" name="baseUrl">
          <Input placeholder="https://api.openai.com/v1 (optional)" />
        </Form.Item>
        <Form.Item label="Default Model" name="defaultModel" rules={[{ required: true }]}>
          <Input placeholder="e.g. gpt-4o, claude-3-opus-20240229" />
        </Form.Item>
        <Form.Item label="Model List" name="modelList">
          <Select
            mode="tags"
            placeholder="Add models (press Enter after each)"
          />
        </Form.Item>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Max Tokens" name="maxTokens">
              <InputNumber style={{ width: '100%' }} min={1} max={1000000} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Priority" name="priority">
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Active" name="isActive" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
